module.exports = __webpack_public_path__ + "assets/img/head.fb83747a.jpg";